"use client";

import { type RefObject, useEffect, useRef } from "react";
import { trackEvent } from "@/lib/analytics/track";

export type AlertSetupAbandonmentSnapshot = {
  location: string;
  ready: boolean;
  routeSlug?: string;
  routeCount: number;
  datesCount: number;
  targetCount?: number;
  partySize: number;
};

export function useAlertSetupAbandonment({
  startedRef,
  submittedRef,
  snapshot,
}: {
  startedRef: RefObject<boolean>;
  submittedRef: RefObject<boolean>;
  snapshot: AlertSetupAbandonmentSnapshot;
}) {
  const snapshotRef = useRef(snapshot);
  const sentRef = useRef(false);

  useEffect(() => {
    snapshotRef.current = snapshot;
  }, [snapshot]);

  useEffect(() => {
    function sendAbandonment() {
      const current = snapshotRef.current;
      if (sentRef.current || submittedRef.current || !startedRef.current) return;
      sentRef.current = true;
      trackEvent("alert_setup_abandoned", {
        location: current.location,
        stage: current.ready ? "ready_not_continued" : "partial_setup",
        ready: current.ready,
        routeSlug: current.routeSlug,
        route_count: current.routeCount,
        dates_count: current.datesCount,
        target_count: current.targetCount ?? current.routeCount * current.datesCount,
        party_size: current.partySize,
      });
    }

    window.addEventListener("pagehide", sendAbandonment);
    return () => window.removeEventListener("pagehide", sendAbandonment);
  }, [startedRef, submittedRef]);
}
